import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { t } from "@lingui/macro";
import FitnessProfileAccordion from "../FitnessProfileAccordion";
import { ClickTarget } from "@/services/Analytics/EventTypes";

type StrengthWeaknessSectionProps = {
  strength: { name: string; description: string; icon: JSX.Element } | undefined;
  weakness: { name: string; description: string; icon: JSX.Element } | undefined;
  analyticsContext?: { name: string; data: Record<string, string> };
  defaultExpanded?: boolean;
  disabled?: boolean;
};

const StrengthWeaknessSection = ({
  strength,
  weakness,
  analyticsContext,
  defaultExpanded = false,
  disabled = false,
}: StrengthWeaknessSectionProps) => {
  const { breakpoints } = useTheme();
  const isSmallScreen = useMediaQuery(breakpoints.down("sm"));

  if (!strength || !weakness) return null;

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.25}
      width="100%"
      pb={2}
      px={isSmallScreen ? 0 : 2}
    >
      <FitnessProfileAccordion
        title={t`Strength`}
        name={strength.name}
        icon={strength.icon}
        isSmallScreen={isSmallScreen}
        defaultExpanded={!isSmallScreen || defaultExpanded}
        details={<Typography>{strength.description}</Typography>}
        analyticsContext={{
          name: analyticsContext?.name ?? "fitness_profile",
          data: { click_target: ClickTarget.strength, ...(analyticsContext?.data ?? {}) },
        }}
        disabled={disabled}
      />

      <FitnessProfileAccordion
        title={t`Weakness`}
        name={weakness.name}
        icon={weakness.icon}
        isSmallScreen={isSmallScreen}
        defaultExpanded={!isSmallScreen || defaultExpanded}
        details={<Typography>{weakness.description}</Typography>}
        analyticsContext={{
          name: analyticsContext?.name ?? "fitness_profile",
          data: { click_target: ClickTarget.weakness, ...(analyticsContext?.data ?? {}) },
        }}
        disabled={disabled}
      />
    </Stack>
  );
};

export default StrengthWeaknessSection;
